// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"main-nav-module--mainNav--35_d-","active":"main-nav-module--active--2DNq-","dark":"main-nav-module--dark--1HxpV","parent":"main-nav-module--parent--v47J2"};